// Globals
import { useTranslation } from 'react-i18next';
import { SearchOutlined } from '@ant-design/icons';

// Models
import { ILLMTemplateVariable } from '@/models/llmTemplate.model';

// Components
import { Input, Spinner } from '@/ui';
import LLMTemplateVariableItem from '../LLMTemplateVariableItem/LLMTemplateVariableItem';
import {
  StyledChipsWrap,
  StyledEmpty,
  StyledPanel,
  StyledSearchWrapper,
  StyledTitle,
} from './LLMTemplateVariablesListStyles';

// Helpers
import { useLLMTemplateVariablesSearch } from '../../hooks';

interface ILLMTemplateVariablesListProps {
  variables: ILLMTemplateVariable[] | null;
  isLoading?: boolean;
}

const LLMTemplateVariablesList = ({ variables, isLoading }: ILLMTemplateVariablesListProps) => {
  const { t } = useTranslation();
  const { query, handleSearchChange, filteredVariables } = useLLMTemplateVariablesSearch(variables);

  return (
    <StyledPanel>
      <StyledTitle>{t('llm_template_variables_title')}</StyledTitle>
      <StyledSearchWrapper>
        <Input
          allowClear
          prefix={<SearchOutlined />}
          placeholder={t('llm_template_variables_search_placeholder')}
          value={query}
          onChange={handleSearchChange}
        />
      </StyledSearchWrapper>
      <Spinner spinning={!!isLoading}>
        <StyledChipsWrap>
          {filteredVariables.map((variable) => (
            <LLMTemplateVariableItem key={variable.code} variable={variable} />
          ))}
          {!isLoading && !filteredVariables.length && <StyledEmpty>{t('llm_template_variables_empty')}</StyledEmpty>}
        </StyledChipsWrap>
      </Spinner>
    </StyledPanel>
  );
};

export default LLMTemplateVariablesList;
